var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3266 3.75012C15.7124 3.75012 14.4037 5.0593 14.4037 6.67392C14.4037 8.28855 15.7124 9.59772 17.3266 9.59772C18.941 9.59772 20.2504 8.28831 20.2504 6.67392C20.2504 5.05954 18.941 3.75012 17.3266 3.75012ZM12.9037 6.67392C12.9037 4.23135 14.8835 2.25012 17.3266 2.25012C19.7694 2.25012 21.7504 4.23111 21.7504 6.67392C21.7504 9.11674 19.7694 11.0977 17.3266 11.0977C14.8835 11.0977 12.9037 9.1165 12.9037 6.67392Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6729 3.75012C5.05953 3.75012 3.75 5.05942 3.75 6.67392C3.75 8.28843 5.05953 9.59772 6.6729 9.59772C8.28807 9.59772 9.5967 8.28843 9.5967 6.67392C9.5967 5.05942 8.28807 3.75012 6.6729 3.75012ZM2.25 6.67392C2.25 4.23123 4.23087 2.25012 6.6729 2.25012C9.11673 2.25012 11.0967 4.23123 11.0967 6.67392C11.0967 9.11662 9.11673 11.0977 6.6729 11.0977C4.23087 11.0977 2.25 9.11662 2.25 6.67392Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3266 14.3383C15.7124 14.3383 14.4037 15.6474 14.4037 17.2621C14.4037 18.8764 15.7122 20.185 17.3266 20.185C18.9412 20.185 20.2504 18.8762 20.2504 17.2621C20.2504 15.6477 18.941 14.3383 17.3266 14.3383ZM12.9037 17.2621C12.9037 14.8195 14.8835 12.8383 17.3266 12.8383C19.7694 12.8383 21.7504 14.8192 21.7504 17.2621C21.7504 19.7051 19.7692 21.685 17.3266 21.685C14.8838 21.685 12.9037 19.7049 12.9037 17.2621Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6729 14.3383C5.05953 14.3383 3.75 15.6476 3.75 17.2621C3.75 18.8763 5.05929 20.185 6.6729 20.185C8.28831 20.185 9.5967 18.8763 9.5967 17.2621C9.5967 15.6476 8.28807 14.3383 6.6729 14.3383ZM2.25 17.2621C2.25 14.8194 4.23087 12.8383 6.6729 12.8383C9.11673 12.8383 11.0967 14.8194 11.0967 17.2621C11.0967 19.705 9.11649 21.685 6.6729 21.685C4.23111 21.685 2.25 19.705 2.25 17.2621Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/Category.18f2f32c3731aac03f48d04ef5d7221c.svg";
export { ForwardRef as ReactComponent };